<template>
	<el-container class="friend-page">
		<el-aside class="page-aside" v-show="!configStore.isMobile || !mobileShowDetail">
			<div class="header" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
				<el-input class="search-text im-session-search" size="small" placeholder="搜索好友昵称或完整账号" v-model="searchText">
					<i class="el-icon-search el-input__icon" slot="prefix"> </i>
				</el-input>
				<el-button
					plain
					class="group-btn im-header-icon-btn"
					icon="el-icon-folder-opened"
					title="好友分组"
					@click="onOpenFriendGroupManager"
				></el-button>
				<el-button
					plain
					class="add-btn im-header-icon-btn"
					icon="el-icon-plus"
					title="添加好友"
					@click="onShowAddFriend()"
				></el-button>
				<add-friend :dialogVisible="showAddFriend" @close="onCloseAddFriend"></add-friend>
				<friend-group-manager ref="friendGroupManager"></friend-group-manager>
			</div>
			<div class="friend-items">
				<div class="top-item" :class="showFriendReuqest ? 'active' : ''" @click="onClickNewFriend">
					<div class="top-item-avatar">
						<div
							class="top-item-avatar-badge"
							aria-hidden="true"
						>
							<i
								class="el-icon-user-solid top-item-avatar-icon"
							></i>
							<span
								class="top-item-avatar-plus"
							>
								<i class="el-icon-plus"></i>
							</span>
						</div>
						<div v-show="recvCount" class="unread-text">{{ recvCount }}</div>
					</div>
					<div class="top-item-info">
						<div class="top-item-name">
							<span>新的朋友</span>
						</div>
					</div>
				</div>
				<div class="divider"></div>
				<empty-state
					v-if="friendRows.length === 0"
					class="friend-list-empty-state"
					icon="el-icon-search"
					:title="friendEmptyTitle"
					compact
				></empty-state>
						<virtual-scroller
							v-else
							ref="friendRowsScroller"
							class="friend-list-virtual"
							:items="friendRows"
							:item-key-getter="getFriendRowKey"
							:item-height="friendListItemHeight"
							:item-height-getter="friendListItemHeightGetter"
							@reach-bottom="onFriendListReachBottom"
						>
					<template v-slot="{ item }">
						<button
							v-if="item.type === 'section'"
							type="button"
							class="section-header"
							@click="toggleSection(item.sectionKey)"
						>
							<i class="el-icon-arrow-down section-arrow" :class="{ 'is-collapsed': item.collapsed }"></i>
							<span class="section-title" :title="item.name">{{ item.name }}</span>
							<span class="section-count">{{ item.count }}</span>
							<i v-if="item.loading" class="el-icon-loading section-loading-icon"></i>
						</button>
						<div v-else-if="item.type === 'loading'" class="section-empty section-empty-row">{{ item.text }}</div>
						<div v-else-if="item.type === 'empty'" class="section-empty section-empty-row">{{ item.text }}</div>
						<friend-item
							v-else
							:id="item.friend.id"
							:friend="item.friend"
							:active="item.friend.id === activeFriendId && !showFriendReuqest"
							@chat="onSendMessage(item.friend)"
							@card="onSendCard(item.friend)"
							@delete="onDelFriend(item.friend)"
							@move-group="onMoveFriendToGroup(item.friend, $event)"
							@click.native="onActiveItem(item.friend)"
						></friend-item>
					</template>
				</virtual-scroller>
			</div>
		</el-aside>
		<div class="friend-main-area" v-show="!configStore.isMobile || mobileShowDetail">
			<div v-if="showFriendReuqest" class="request-panel">
				<div v-if="configStore.isMobile" class="mobile-back-header">
					<i class="el-icon-arrow-left" @click="onMobileBack"></i>
					<span class="mobile-back-title">新的朋友</span>
				</div>
				<div v-else class="header" :class="configStore.electronMode ? 'header-menu-wrap' : ''">新的朋友</div>
				<friend-request class="request-box"></friend-request>
			</div>
			<chat-box v-else-if="activeFriendChat" :chat="activeFriendChat" @back="onMobileBack"></chat-box>
			<empty-state
				v-else
				class="content-empty-state"
				icon="el-icon-user-solid"
				title="选择一位好友开始聊天"
				hint="联系人资料和操作可在单聊会话右侧资料抽屉中查看"
			></empty-state>
		</div>
		<chat-selector ref="chatSel" title="分享名片"></chat-selector>
	</el-container>
</template>

<script>
import FriendItem from "../components/friend/FriendItem.vue";
import AddFriend from "../components/friend/AddFriend.vue";
import FriendGroupManager from "../components/friend/FriendGroupManager.vue";
import FriendRequest from "../components/friend/FriendRequest.vue";
import ChatSelector from "../components/chat/ChatSelector.vue";
import ChatBox from "../components/chat/ChatBox.vue";
import VirtualScroller from "../components/common/VirtualScroller.vue";
import { CONTACT_SEARCH_TEXT_KEY, matchesPreparedContactKeyword } from "../utils/contactSearchMatcher";
import {
	extractForwardErrorMessage,
	normalizeForwardMessages,
	prepareForwardTargets
} from "../utils/messageForward.js";

function normalizeIds(ids) {
	return Array.isArray(ids)
		? ids.filter((id, index, list) => id && list.indexOf(id) === index)
		: [];
}

function resolveIdKey(id) {
	if (id === undefined || id === null || id === '') {
		return '';
	}
	return String(id);
}

export default {
	name: "friend",
	components: {
		FriendItem,
		AddFriend,
		FriendGroupManager,
		FriendRequest,
		ChatSelector,
		ChatBox,
		VirtualScroller
	},
	data() {
		return {
			searchText: "",
			showAddFriend: false,
			activeFriendId: null,
			showFriendReuqest: false,
			mobileShowDetail: false,
			collapsedSections: {},
			sectionLoadingMap: {}
		};
	},
	methods: {
		initializeGroupCollapsedState() {
			const validSectionKeys = new Set(['ungrouped']);
			this.friendGroupStore.groups.forEach((group) => {
				if (!group || !group.id) {
					return;
				}
				const sectionKey = this.resolveSectionKey(group.id);
				validSectionKeys.add(sectionKey);
				if (!Object.prototype.hasOwnProperty.call(this.collapsedSections, sectionKey)) {
					this.$set(this.collapsedSections, sectionKey, true);
				}
			});
			Object.keys(this.collapsedSections).forEach((sectionKey) => {
				if (validSectionKeys.has(sectionKey)) {
					return;
				}
				this.$delete(this.collapsedSections, sectionKey);
			});
			Object.keys(this.sectionLoadingMap).forEach((sectionKey) => {
				if (validSectionKeys.has(sectionKey)) {
					return;
				}
				this.$delete(this.sectionLoadingMap, sectionKey);
			});
		},
		getFriendListRowHeight(item) {
			if (item && item.type === 'friend') {
				return this.friendRowHeight;
			}
			if (item && item.type === 'empty') {
				return 48;
			}
			return 44;
		},
		buildPrivateChat(friend) {
			return {
				type: 'PRIVATE',
				targetId: friend.id,
				showName: friend.showNickName || friend.nickName || friend.userName,
				headImage: friend.headImage,
				userName: friend.userName
			};
		},
		ensurePrivateChat(friend) {
			const chat = this.buildPrivateChat(friend);
			this.chatStore.openChat(chat);
			return this.chatStore.findChatByFriend(friend.id);
		},
		async sendForwardMessages(chats, messages, options = {}) {
			const forwardTarget = prepareForwardTargets(chats);
			const targets = forwardTarget.targets;
			const forwardMessages = normalizeForwardMessages(messages);
			if (targets.length === 0) {
				this.$message.warning('请选择转发目标');
				return null;
			}
			if (forwardMessages.length === 0) {
				this.$message.warning('没有可发送的消息');
				return null;
			}
			if (forwardTarget.truncated) {
				this.$message.warning(`已选择 ${forwardTarget.originalCount} 个会话，本次仅转发前 ${forwardTarget.limit} 个会话`);
			}
			try {
				return await this.$http({
					url: '/message/forward',
					method: 'post',
					data: {
						targets,
						messages: forwardMessages
					},
					_skipErrorMessage: true
				});
			} catch (error) {
				this.$message.error(extractForwardErrorMessage(error) || options.failText || '发送失败');
				return null;
			}
		},
		syncRouteFriend() {
			const friendId = Number(this.$route.query.id || 0);
			if (!friendId) {
				return;
			}
			const friend = this.friendStore.findFriend(friendId);
			if (!friend || friend.deleted) {
				return;
			}
			this.expandFriendSection(friend.id);
			this.onActiveItem(friend);
			this.$nextTick(() => {
				this.locateItem(friend.id);
			});
		},
		onShowAddFriend() {
			this.showAddFriend = true;
		},
		onCloseAddFriend() {
			this.showAddFriend = false;
		},
		onOpenFriendGroupManager() {
			if (this.$refs.friendGroupManager) {
				this.$refs.friendGroupManager.open();
			}
		},
			onActiveItem(friend) {
				if (!friend || friend.deleted) {
					return;
				}
				const group = this.friendGroupStore.findGroupByFriendId(friend.id)
					|| this.friendGroupStore.findGroup(friend.groupId);
				if (group && group.id) {
					this.expandFriendSection(friend.id);
				}
				this.activeFriendId = friend.id;
				this.showFriendReuqest = false;
				this.mobileShowDetail = true;
				this.ensurePrivateChat(friend);
			},
		onDelFriend(friend) {
			if (!friend) {
				return;
			}
			const friendName = friend.showNickName || friend.nickName;
			this.$confirm(`确认删除'${friendName}',并清空聊天记录吗?`, '确认解除?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/friend/delete/${friend.id}`,
					method: 'delete'
				}).then(() => {
					this.$message.success("删除好友成功");
					this.friendStore.removeFriend(friend.id);
					this.friendGroupStore.removeFriend(friend.id);
					this.chatStore.removePrivateChat(friend.id);
					this.reset(friend.id);
				});
			});
		},
		onSendMessage(friend) {
			if (!friend || friend.deleted) {
				return;
			}
			const chat = this.buildPrivateChat(friend);
			this.chatStore.openChat(chat);
			this.chatStore.setActiveChat(chat);
			this.$router.push("/home/chat");
		},
		onSendCard(friend) {
			if (!this.$permission.canForwardCardMessage()) {
				this.$message.error('您没有名片转发权限');
				return;
			}
			this.$refs.chatSel.open(async (chats) => {
				const cardData = {
					userId: friend.id,
					nickName: friend.nickName,
					headImage: friend.headImage
				};
				await this.sendForwardMessages(chats, [{
					type: this.$enums.MESSAGE_TYPE.USER_CARD,
					content: JSON.stringify(cardData)
				}], {
					successText: '发送成功',
					failText: '发送失败'
				});
			});
		},
		onClickNewFriend() {
			this.activeFriendId = null;
			this.showFriendReuqest = true;
			this.mobileShowDetail = true;
		},
		handleEscape() {
			if (this.showAddFriend) {
				this.onCloseAddFriend();
				return true;
			}
			if (this.$refs.friendGroupManager && this.$refs.friendGroupManager.show) {
				this.$refs.friendGroupManager.close();
				return true;
			}
			if (this.$refs.chatSel && this.$refs.chatSel.show) {
				this.$refs.chatSel.close();
				return true;
			}
			if (this.showFriendReuqest || this.activeFriendId) {
				this.closeDetailPanel();
				return true;
			}
			return false;
		},
		onMobileBack() {
			this.mobileShowDetail = false;
		},
		closeDetailPanel() {
			this.activeFriendId = null;
			this.showFriendReuqest = false;
			this.mobileShowDetail = false;
		},
		reset(friendId) {
			if (this.activeFriendId && this.activeFriendId == friendId) {
				this.activeFriendId = null;
				this.mobileShowDetail = false;
			}
		},
		locateItem(id) {
			const rowIndex = this.friendRows.findIndex((row) => row.type === 'friend' && row.friend.id == id);
			if (rowIndex < 0 || !this.$refs.friendRowsScroller || !this.$refs.friendRowsScroller.scrollToIndex) {
				return;
			}
			this.$refs.friendRowsScroller.scrollToIndex(rowIndex, {
				align: 'center'
			});
		},
		resolveSectionKey(groupId) {
			return groupId ? `group-${groupId}` : 'ungrouped';
		},
		expandFriendSection(friendId) {
			const friend = this.friendStore.findFriend(friendId);
			const group = this.friendGroupStore.findGroupByFriendId(friendId)
				|| this.friendGroupStore.findGroup(friend && friend.groupId);
			const sectionKey = this.resolveSectionKey(group && group.id);
			this.$set(this.collapsedSections, sectionKey, false);
			this.ensureSectionFriendsLoaded(sectionKey);
		},
		toggleSection(sectionKey) {
			if (String(this.searchText || '').trim()) {
				return;
			}
			const nextCollapsed = !this.collapsedSections[sectionKey];
			this.$set(this.collapsedSections, sectionKey, nextCollapsed);
			if (!nextCollapsed) {
				this.ensureSectionFriendsLoaded(sectionKey);
			}
		},
		isSectionCollapsed(sectionKey) {
			if (String(this.searchText || '').trim()) {
				return false;
			}
			return this.collapsedSections[sectionKey] !== false;
		},
			isSectionLoading(sectionKey) {
				return Boolean(this.sectionLoadingMap[sectionKey]);
			},
			getFriendRowKey(row) {
				if (!row) {
					return '';
				}
				if (row.type === 'friend') {
					const friendId = row.friend && row.friend.id;
					if (!friendId) {
						return '';
					}
					return `friend:${row.sectionKey || 'unknown'}:${friendId}`;
				}
				return row.key || '';
			},
			extractGroupIdBySectionKey(sectionKey) {
				if (!sectionKey || !String(sectionKey).startsWith('group-')) {
					return null;
				}
			const rawId = String(sectionKey).slice('group-'.length).trim();
			return rawId ? rawId : null;
		},
		async ensureSectionFriendsLoaded(sectionKey) {
			if (!sectionKey || sectionKey === 'ungrouped') {
				return;
			}
			const groupId = this.extractGroupIdBySectionKey(sectionKey);
			if (!groupId || this.isSectionLoading(sectionKey)) {
				return;
			}
			this.$set(this.sectionLoadingMap, sectionKey, true);
			try {
				await this.friendGroupStore.ensureGroupFriendsFullyLoaded(groupId, {
					limit: 30,
					includeOnline: false
				});
				} catch (error) {
					console.warn('加载分组好友详情失败', groupId, error);
				} finally {
					this.$delete(this.sectionLoadingMap, sectionKey);
				}
			},
		async onMoveFriendToGroup(friend, item) {
			if (!friend || !item || item.disabled) {
				return;
			}
			const currentGroup = this.friendGroupStore.findGroupByFriendId(friend.id)
				|| this.friendGroupStore.findGroup(friend.groupId);
			const nextGroupId = Object.prototype.hasOwnProperty.call(item, 'groupId') ? item.groupId : null;
			if (!currentGroup && !nextGroupId) {
				return;
			}
			if (currentGroup && nextGroupId && currentGroup.id === nextGroupId) {
				return;
			}
			const displayName = friend.showNickName || friend.nickName || friend.userName || '该好友';
			try {
				if (!nextGroupId) {
					const currentGroupFriends = await this.friendGroupStore.ensureGroupFriendsFullyLoaded(currentGroup.id, {
						limit: 30,
						includeOnline: false
					});
					const group = await this.$http({
						url: `/friend/group/${currentGroup.id}/members`,
						method: 'put',
						data: {
							friendIds: normalizeIds((currentGroupFriends || [])
								.map((friendItem) => friendItem && friendItem.id)
								.filter(Boolean)
								.filter((friendId) => friendId !== friend.id))
						}
					});
					this.friendGroupStore.upsertGroup(group);
					this.friendGroupStore.moveFriend(friend.id, null);
					this.expandFriendSection(friend.id);
					this.$message.success(`已将“${displayName}”移动到“我的好友”`);
					return;
				}
				const targetGroup = this.friendGroupStore.findGroup(nextGroupId);
				if (!targetGroup) {
					this.$message.warning('目标好友分组不存在');
					return;
				}
				const targetGroupFriends = await this.friendGroupStore.ensureGroupFriendsFullyLoaded(targetGroup.id, {
					limit: 30,
					includeOnline: false
				});
				const group = await this.$http({
					url: `/friend/group/${targetGroup.id}/members`,
					method: 'put',
					data: {
						friendIds: normalizeIds((targetGroupFriends || [])
							.map((friendItem) => friendItem && friendItem.id)
							.filter(Boolean)
							.concat(friend.id))
					}
				});
				this.friendGroupStore.upsertGroup(group);
				this.friendGroupStore.moveFriend(friend.id, targetGroup.id);
				this.expandFriendSection(friend.id);
				this.$message.success(`已将“${displayName}”移动到“${targetGroup.name}”`);
			} catch (error) {
				this.$message.error(this.extractErrorMessage(error) || '移动好友分组失败');
			}
		},
		extractErrorMessage(error) {
			if (error && typeof error.message === 'string' && error.message) {
				return error.message;
			}
			if (error && typeof error.msg === 'string' && error.msg) {
				return error.msg;
			}
			if (error && error.response && error.response.data) {
				const responseData = error.response.data;
				if (typeof responseData === 'string' && responseData) {
					return responseData;
				}
				if (typeof responseData.message === 'string' && responseData.message) {
					return responseData.message;
				}
			}
			return '';
		},
			onFriendListReachBottom() {
				if (this.normalizedSearchText) {
					return;
				}
				if (this.$refs.friendGroupManager && this.$refs.friendGroupManager.show) {
					return;
				}
				if (this.friendStore.page.loading) {
					return;
				}
				if (this.friendStore.page.more && this.friendStore.page.cursor) {
					this.friendStore.loadMoreFriendsFromCursor({
						maxPages: 1
					}).catch((error) => {
						console.warn('滚动续拉好友分页失败', error);
					});
				}
				if (this.friendGroupStore.page.more
					&& this.friendGroupStore.page.cursor
					&& !this.friendGroupStore.page.loading) {
					this.friendGroupStore.loadMoreGroupsFromCursor({
						limit: 30,
						maxPages: 1
					}).catch((error) => {
						console.warn('滚动续拉好友分组分页失败', error);
					});
				}
				this.loadMoreExpandedSectionFriends().catch((error) => {
					console.warn('滚动续拉好友分组成员失败', error);
				});
			},
		getFriendRowsScrollerMetrics() {
			const friendRowsScroller = this.$refs.friendRowsScroller;
			const container = friendRowsScroller && friendRowsScroller.$refs
				? friendRowsScroller.$refs.container
				: null;
			if (!container) {
				return null;
			}
			return {
				scrollHeight: container.scrollHeight,
				clientHeight: container.clientHeight
			};
		},
		maybeAutoLoadFriendRows() {
			if (this.normalizedSearchText) {
				return;
			}
			if (this.$refs.friendGroupManager && this.$refs.friendGroupManager.show) {
				return;
			}
				if (this.friendStore.page.loading) {
					return;
				}
				const moreFriends = this.friendStore.page.more && this.friendStore.page.cursor;
				const moreFriendGroups = this.friendGroupStore.page.more && this.friendGroupStore.page.cursor;
				if (!moreFriends && !moreFriendGroups) {
					return;
				}
			this.$nextTick(() => {
				const metrics = this.getFriendRowsScrollerMetrics();
				if (!metrics) {
					return;
				}
				if (metrics.scrollHeight > metrics.clientHeight + 4) {
					return;
				}
				this.onFriendListReachBottom();
			});
		},
		async loadMoreExpandedSectionFriends() {
			// 好友分组成员已切换为“展开时全量加载”，不再做滚动分页续拉。
		}
	},
	computed: {
		friendRowHeight() {
			return 76;
		},
		friendListItemHeight() {
			return this.normalizedSearchText ? this.friendRowHeight : 0;
		},
		friendListItemHeightGetter() {
			return this.normalizedSearchText ? null : this.getFriendListRowHeight;
		},
		mine() {
			return this.userStore.userInfo;
		},
		activeFriendChat() {
			if (!this.activeFriendId) {
				return null;
			}
			return this.chatStore.findChatByFriend(this.activeFriendId);
		},
		normalizedSearchText() {
			return String(this.searchText || '').trim().toLowerCase();
		},
		friendMatchState() {
			const matchedMap = new Map();
			const myFriends = [];
			const keyword = this.normalizedSearchText;
			const assignedFriendMap = this.friendGroupStore.friendToGroupMap;
			if (!keyword) {
				this.friendStore.friends.forEach((friend) => {
					if (!friend || friend.deleted) {
						return;
					}
					const friendKey = resolveIdKey(friend.id);
					if (!friendKey) {
						return;
					}
					const friendGroupKey = resolveIdKey(friend.groupId) || assignedFriendMap.get(friendKey);
					if (!friendGroupKey) {
						myFriends.push(friend);
					}
				});
				return {
					matchedMap,
					matchedFriends: [],
					myFriends
				};
			}
			const matchedFriends = [];
			this.friendStore.friends.forEach((friend) => {
				if (!friend || friend.deleted) {
					return;
				}
				if (!matchesPreparedContactKeyword(friend[CONTACT_SEARCH_TEXT_KEY], keyword)) {
					return;
				}
				const friendKey = resolveIdKey(friend.id);
				if (!friendKey) {
					return;
				}
				matchedMap.set(friendKey, friend);
				matchedFriends.push(friend);
				const friendGroupKey = resolveIdKey(friend.groupId);
				const mappedGroupKey = friendGroupKey || assignedFriendMap.get(friendKey);
				if (!mappedGroupKey) {
					myFriends.push(friend);
				}
			});
			return {
				matchedMap,
				matchedFriends,
				myFriends
			};
		},
		matchedFriendMap() {
			return this.friendMatchState.matchedMap;
		},
		matchedFriends() {
			return this.friendMatchState.matchedFriends;
		},
		friendSections() {
			const keyword = this.normalizedSearchText;
			const sections = [];
			const { matchedMap, myFriends } = this.friendMatchState;
			if (!keyword || myFriends.length > 0) {
				sections.push({
					key: this.resolveSectionKey(null),
					name: '我的好友',
					friends: myFriends,
					count: myFriends.length,
					emptyText: '暂无我的好友'
				});
			}
			this.friendGroupStore.groups.forEach((group) => {
				if (!group || !group.id) {
					return;
				}
				const sectionKey = this.resolveSectionKey(group.id);
				const collapsed = this.isSectionCollapsed(sectionKey);
				let friends = [];
				if (!keyword && collapsed) {
					friends = [];
				} else if (!keyword) {
					friends = this.friendGroupStore.findGroupFriends(group.id).filter((friend) => friend && !friend.deleted);
				} else {
					const groupFriends = this.friendGroupStore.findGroupFriends(group.id);
					friends = groupFriends
						.map((friend) => matchedMap.get(resolveIdKey(friend && friend.id)))
						.filter(Boolean);
				}
				if (!keyword || friends.length > 0) {
					const memberCount = Number.isFinite(Number(group.memberCount))
						? Number(group.memberCount)
						: 0;
					sections.push({
						key: sectionKey,
						name: group.name || '未命名分组',
						friends,
						count: memberCount,
						emptyText: '暂无分组好友'
					});
				}
			});
			return sections;
		},
		friendRows() {
			if (this.normalizedSearchText) {
				return this.matchedFriends.map((friend) => ({
					key: `friend-${friend.id}`,
					type: 'friend',
					sectionKey: 'search',
					friend
				}));
			}
			const rows = [];
			this.friendSections.forEach((section) => {
				const collapsed = this.isSectionCollapsed(section.key);
				rows.push({
					key: `section-${section.key}`,
					type: 'section',
					sectionKey: section.key,
					name: section.name,
					count: section.count,
					collapsed,
					loading: this.isSectionLoading(section.key)
				});
				if (collapsed) {
					return;
				}
				if (this.isSectionLoading(section.key)) {
					rows.push({
						key: `loading-${section.key}`,
						type: 'loading',
						sectionKey: section.key,
						text: '加载中...'
					});
					return;
				}
				if (section.friends.length === 0) {
					rows.push({
						key: `empty-${section.key}`,
						type: 'empty',
						sectionKey: section.key,
						text: section.emptyText
					});
					return;
				}
				section.friends.forEach((friend) => {
					rows.push({
						key: `friend-${friend.id}`,
						type: 'friend',
						sectionKey: section.key,
						friend
					});
				});
			});
			return rows;
		},
		friendEmptyTitle() {
			return String(this.searchText || '').trim() ? '未找到匹配联系人' : '暂无联系人';
		},
		recvCount() {
			return this.friendStore.requests.filter((req) => req.recvId == this.mine.id).length;
		}
	},
	watch: {
		'$route.query.id'() {
			this.syncRouteFriend();
		},
		'friendGroupStore.groups'() {
			this.initializeGroupCollapsedState();
		},
		'friendRows.length'() {
			this.maybeAutoLoadFriendRows();
		}
	},
	mounted() {
		this.syncRouteFriend();
		this.initializeGroupCollapsedState();
		this.maybeAutoLoadFriendRows();
	}
};
</script>

<style lang="scss">
@import "../assets/style/responsive";

.friend-page {
	height: 100%;
	min-height: 0;

		.page-aside {
		width: clamp(280px, 28vw, 312px);
		min-width: 0;
		display: flex;
		flex-direction: column;
		flex-shrink: 0;
		background: var(--im-session-bg);
		background-image: none;
		border-right: 1px solid var(--im-surface-panel-border);

		@include mobile {
			width: 100%;
			flex: 1 1 auto;
			border-right: none;
		}

		.header {
			height: 64px;
			display: flex;
			align-items: center;
			gap: 8px;
			padding: 0 12px;
			background: var(--im-session-bg);
			background-image: none;

			.search-text {
				flex: 1;
				min-width: 0;
			}

			.add-btn {
				flex-shrink: 0;
			}
		}
	}

	.friend-main-area {
		flex: 1;
		display: flex;
		min-width: 0;
		overflow: hidden;
		background: var(--im-chat-bg);

		> .chat-box {
			flex: 1;
			min-width: 0;
		}
	}

	.request-panel {
		flex: 1;
		display: flex;
		flex-direction: column;
		min-width: 0;
		background: var(--im-chat-bg);

		> .header {
			min-height: 60px;
			display: flex;
			align-items: center;
			padding: 0 12px;
			box-sizing: border-box;
			background: var(--im-chat-bg);
			border-bottom: 1px solid var(--im-surface-panel-border);
			color: var(--im-text-color);
		}
	}

	.request-box {
		flex: 1;
		min-height: 0;
	}

	.mobile-back-header {
		display: flex;
		align-items: center;
		gap: 8px;
		min-height: 52px;
		padding: 0 12px;
		background: var(--im-session-bg);
		border-bottom: 1px solid var(--im-surface-panel-border);
		flex-shrink: 0;

		.el-icon-arrow-left {
			font-size: 18px;
			cursor: pointer;
			padding: 6px;
			color: var(--im-session-text);
			background: var(--im-session-hover-bg);
			border-radius: 12px;
			transition: all 0.2s ease;
			flex-shrink: 0;

			&:hover {
				background: var(--im-session-active-bg);
				transform: scale(1.05);
			}

			&:active {
				transform: scale(0.95);
			}
		}

		.mobile-back-title {
			flex: 1;
			min-width: 0;
			font-size: var(--im-font-size-large);
			font-weight: 500;
			color: var(--im-session-text);
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	.divider {
		border-bottom: 1px var(--im-border-color) solid;
		margin: 4px 12px 2px;
	}

	.friend-items {
		flex: 1;
		display: flex;
		flex-direction: column;
		min-height: 0;
		background: var(--im-session-bg);

		.top-item {
			height: 64px;
			display: flex;
			position: relative;
			padding: 8px 12px;
			align-items: center;
			white-space: nowrap;
			cursor: pointer;
			border-radius: 0;

			&::before {
				content: '';
				position: absolute;
				left: 0;
				top: 50%;
				transform: translateY(-50%) scaleY(0);
				width: 2px;
				height: 20px;
				border-radius: 0 2px 2px 0;
				background: var(--im-session-indicator);
				transition: transform 0.2s ease;
			}

			&:hover {
				background-color: var(--im-session-hover-bg);
			}

			&.active {
				background-color: var(--im-session-active-bg);

				&::before {
					transform: translateY(-50%) scaleY(1);
				}

				.top-item-name {
					font-weight: 600;
				}
			}

			.top-item-avatar {
				position: relative;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 42px;
				height: 42px;

				.top-item-avatar-badge {
					position: relative;
					display: inline-flex;
					align-items: center;
					justify-content: center;
					width: 42px;
					height: 42px;
					border-radius: 14px;
					background:
						radial-gradient(circle at 30% 24%, rgba(var(--im-white-rgb), 0.18), transparent 52%),
						linear-gradient(145deg, rgba(var(--im-white-rgb), 0.08), rgba(var(--im-black-rgb), 0.12)),
						var(--im-avatar-bg-1, var(--im-color-primary));
					box-shadow: inset 0 0 0 1px var(--im-avatar-border, rgba(var(--im-black-rgb), 0.06));
				}

				.top-item-avatar-icon {
					font-size: 18px;
					color: var(--im-text-color-white);
					transform: translateY(-1px);
				}

				.top-item-avatar-plus {
					position: absolute;
					right: -1px;
					bottom: -1px;
					display: inline-flex;
					align-items: center;
					justify-content: center;
					width: 16px;
					height: 16px;
					border-radius: 999px;
					background: var(--im-chat-bg);
					border: 1px solid var(--im-avatar-border, rgba(var(--im-primary-rgb), 0.16));
					color: var(--im-color-primary);

					i {
						font-size: 10px;
						font-weight: 700;
					}
				}

				.unread-text {
					position: absolute;
					background-color: var(--im-color-danger);
					right: -6px;
					top: -6px;
					color: white;
					border-radius: 30px;
					padding: 1px 5px;
					font-size: 10px;
					text-align: center;
					white-space: nowrap;
					border: 2px solid var(--im-session-bg);
				}
			}

			.top-item-info {
				flex: 1;
				display: flex;
				flex-direction: column;
				padding-left: 12px;
				text-align: left;

				.top-item-name {
					display: inline-flex;
					align-items: center;
					gap: 6px;
					font-size: 14px;
					font-weight: 500;
					color: var(--im-session-text);
					white-space: nowrap;
					overflow: hidden;
				}
			}
		}
	}

	.friend-list-virtual {
		flex: 1;
		min-height: 0;

		::v-deep .virtual-content {
			padding: 0 0 6px;
		}
	}

	.friend-list-empty-state {
		min-height: 180px;
		background: var(--im-session-bg);
	}

	.section-header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		gap: 5px;
		padding: 0 12px 0 7px;
		border: none;
		background: transparent;
		color: var(--im-session-text-muted);
		cursor: pointer;
		text-align: left;
		transition: background-color 0.15s ease;

		&:hover {
			background: transparent;
		}
	}

	.section-arrow {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 13px;
		font-size: 11px;
		color: var(--im-text-color-light);
		text-align: center;
		transition: transform 0.18s ease;

		&.is-collapsed {
			transform: rotate(-90deg);
		}
	}

	.section-title {
		flex: 1;
		min-width: 0;
		font-size: 14px;
		font-weight: 500;
		line-height: 20px;
		color: var(--im-session-text);
		letter-spacing: 0.02em;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.section-count {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		min-width: 18px;
		height: 16px;
		padding: 0 6px;
		line-height: 16px;
		text-align: center;
		border-radius: 999px;
		background: rgba(var(--im-primary-rgb), 0.08);
		font-size: 10px;
		font-weight: 600;
		color: var(--im-color-primary);
	}

	.section-loading-icon {
		flex-shrink: 0;
		font-size: 12px;
		color: var(--im-text-color-light);
	}

	.section-empty {
		padding: 0 12px 4px 26px;
		font-size: 11px;
		color: var(--im-text-color-light);
		text-align: left;
	}

	.section-empty-row {
		height: 44px;
		display: flex;
		align-items: center;
	}

	.content-empty-state {
		background: var(--im-chat-bg);
		user-select: none;
	}
}
</style>
